const BASE = `${process.env.PUBLIC_URL || ''}/mes-patrio/sfx`;

const BOOMS = [
  `${BASE}/boom-1.mp3`,
  `${BASE}/boom-2.mp3`,
  `${BASE}/boom-3.mp3`,
  `${BASE}/boom-4.mp3`,
  `${BASE}/boom-5.mp3`
];
const LIFT = `${BASE}/lift.mp3`;
const NIGHT = `${BASE}/night.mp3`;
const BARRAGE = `${BASE}/barrage.mp3`;

function pick(list) {
  return list[Math.floor(Math.random() * list.length)];
}

export function createFireworksAudio() {
  BOOMS.concat(LIFT, NIGHT, BARRAGE).forEach((src) => {
    const preload = new Audio();
    preload.preload = 'auto';
    preload.src = src;
  });

  const live = new Set();
  let unlocked = false;
  let lastBoom = 0;
  let lastLift = 0;
  let bedTimer = 0;

  const stopAll = () => {
    live.forEach((node) => {
      node.pause();
      node.src = '';
    });
    live.clear();
  };

  const play = (src, { volume = 0.45, rate = 1 } = {}) => {
    if (!unlocked) return;
    const node = new Audio(src);
    node.volume = Math.max(0, Math.min(1, volume));
    node.playbackRate = rate;
    live.add(node);
    node.addEventListener('ended', () => live.delete(node), { once: true });
    node.play().catch(() => {
      live.delete(node);
    });
    if (live.size > 6) {
      const oldest = live.values().next().value;
      if (oldest) {
        oldest.pause();
        live.delete(oldest);
      }
    }
  };

  const startBed = () => {
    play(NIGHT, { volume: 0.22, rate: 1 });
    window.clearTimeout(bedTimer);
    bedTimer = window.setTimeout(() => {
      play(BARRAGE, { volume: 0.28, rate: 1 });
    }, 4200);
  };

  const unlock = () => {
    if (unlocked) return;
    unlocked = true;
    startBed();
  };

  const tryUnlock = () => {
    if (unlocked) return;
    if (navigator.userActivation?.hasBeenActive) {
      unlock();
      return;
    }
    const probe = new Audio(NIGHT);
    probe.volume = 0.01;
    probe.play()
      .then(() => {
        probe.pause();
        unlock();
      })
      .catch(() => {});
  };

  const onGesture = () => unlock();
  window.addEventListener('pointerdown', onGesture, { capture: true });
  window.addEventListener('keydown', onGesture, { capture: true });
  tryUnlock();

  return {
    lift(now) {
      if (now - lastLift < 380) return;
      lastLift = now;
      play(LIFT, {
        volume: 0.22 + Math.random() * 0.08,
        rate: 0.94 + Math.random() * 0.14
      });
    },
    boom(now) {
      if (now - lastBoom < 210) return;
      lastBoom = now;
      play(pick(BOOMS), {
        volume: 0.38 + Math.random() * 0.16,
        rate: 0.9 + Math.random() * 0.18
      });
    },
    dispose() {
      window.removeEventListener('pointerdown', onGesture, { capture: true });
      window.removeEventListener('keydown', onGesture, { capture: true });
      window.clearTimeout(bedTimer);
      stopAll();
    }
  };
}
